import {
  Column,
  Container,
  Row,
  Spacer
} from '@smuchile/pkg-unimarc-components'
import {
  BigScreen,
  getGlobalStyle,
  SmallScreen
} from '@smuchile/pkg-unimarc-components/helpers'
import { DAYS } from 'shared/constants'
import { DeliveryDate } from './DeliveryDate'
import { PaymentMethods } from './PaymentMethods'
import { Shipping } from './Shipping'
import { timeUTCFilter } from 'shared/helpers'
import { capitalize, formatDate, useMobile } from '@smuchile/pkg-unimarc-hooks'
import { TextPostPicking } from './PaymentMethods/TextPostPicking'
import { IOrder } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrder'
import { PAYMENT_WEB_PAY_NAMES } from 'shared/helpers/paymentSystems'

enum AddressType {
  Residential = 'residential'
}

interface ShippingTypeProps {
  bankStateImage: string
  order?: IOrder
}

export const ShippingType = ({ bankStateImage, order }: ShippingTypeProps) => {
  const { isMobile } = useMobile()

  const paymentName = order?.inscription?.paymentName ?? ''

  const { shippingData } = order

  const {
    address: { addressType, street, number, neighborhood, state, complement },
    logisticsInfo
  } = shippingData
  const numberDepartament = complement ? `, ${complement},` : ','
  const icon = addressType === AddressType.Residential ? 'Motorcycle' : 'Shop'
  const tittle =
    addressType === AddressType.Residential
      ? 'Despacho a domicilio:'
      : 'Retiro en tienda:'
  const deliveryAddress =
    addressType === AddressType.Residential
      ? `${street} ${number}${numberDepartament} ${neighborhood}, ${capitalize(
          state
        )}.`
      : `${logisticsInfo[0]?.pickupStoreInfo
          ?.friendlyName} - ${street} ${number}${numberDepartament} ${neighborhood}, ${capitalize(
          state
        )}.`
  let deliveryDateText
  if (logisticsInfo[0].deliveryWindow) {
    const { startDateUtc, endDateUtc } = logisticsInfo[0].deliveryWindow
    const startDate = new Date(startDateUtc)
    const endDate = new Date(endDateUtc)
    deliveryDateText = `${DAYS[startDate.getDay()]} ${formatDate(
      startDateUtc
    ).replace(/-/gi, '/')}, ${timeUTCFilter(startDate)} - ${timeUTCFilter(
      endDate
    )} hrs.`
  }

  const paddingDesktopMessageWebPay = isMobile
    ? '15px 10px 5px 10px'
    : '18px 30px'

  return (
    <>
      <BigScreen>
        <Container
          backgroundColor={getGlobalStyle('--color-neutral-gray-light')}
          borderRadius='4px'
          isWrap
          tagName='section'
        >
          <Row
            borderRadius='4px'
            minHeight='100px'
            tagName='article'
          >
            <Column>
              <Shipping
                address={deliveryAddress}
                icon={icon}
                tittle={tittle}
              />
            </Column>
            <Column>
              <DeliveryDate
                deliveryDate={deliveryDateText ? deliveryDateText : ''}
              />
            </Column>
            <Column>
              <PaymentMethods
                bankStateImage={bankStateImage}
                order={order}
              />
            </Column>
          </Row>

          {paymentName === PAYMENT_WEB_PAY_NAMES[0] && (
            <Row
              isWrap
              margin={paddingDesktopMessageWebPay}
            >
              <Spacer.Horizontal
                backgroundColor={getGlobalStyle('--color-neutral-gray')}
                size={1}
              />
              <Spacer.Horizontal size={8} />
              <TextPostPicking />
            </Row>
          )}
        </Container>
      </BigScreen>
      <SmallScreen>
        <Container
          isWrap
          margin='0 12px'
        >
          <Row isWrap>
            <Column>
              <Shipping
                address={deliveryAddress}
                icon={icon}
                tittle={tittle}
              />
            </Column>
            <Spacer.Horizontal size={16} />
            <Column>
              <DeliveryDate
                deliveryDate={deliveryDateText ? deliveryDateText : ''}
              />
            </Column>
          </Row>
          <Spacer.Horizontal size={16} />
          <Row>
            <Column>
              <PaymentMethods
                bankStateImage={bankStateImage}
                order={order}
              />
            </Column>
          </Row>
        </Container>
      </SmallScreen>
    </>
  )
}
